import React from "react";

type Props = {};

export const NotFoundPage = (props: Props) => {
	return <div>NotFoundPage</div>;
};
